import { Guid } from './Shared';

export interface CompanyContactDataRoom {
	guid: Guid;
	dataRoomGuid: Guid;
	isAdmin: boolean;
	isBillingContact: boolean;
	allowAccess: boolean;
	createdOn: Date;
	modifiedOn: Date;
	decisionOn: Date;
	lastAccessedOn: Date;
	lastInviteSent: Date;

	personId: number;
	companyContactGuid: Guid;
	companyGuid: Guid;
	firstName: string;
	lastName: string;
	emailAddress: string;
	accessType: CompanyContactDataRoomAccessType;
	isActive: boolean;
	isThirdPartyContact: boolean;
}

export type CompanyContactDataRoomAccessType = keyof typeof CompanyContactDataRoomAccessTypeMap;
export const CompanyContactDataRoomAccessTypeMap = {
	FullAccess: 'Full Access',
	LimitedAccess: 'Limited Access',
	NoAccess: 'No Access',
};
